/* eslint-disable import/prefer-default-export */
import reduxFreeFetcher, { simpleFetch as fetch } from '@api/fetchers';
import { HOST_TYPE, getHost } from '@utils/api-helper/host';

const defaultHost = getHost();
const backendHost = getHost(HOST_TYPE.BACKEND_API_HOST);

export const fetchPracticeByEducators = (goalUID = '', authorization) =>
  fetch(
    `${defaultHost}v1/quizzes/learner_dpp_practice/practice_home/?goal_uid=${goalUID}`,
    { authorization }
  ).catch(() => {});

export const fetchFreePracticeTopologies = ({ goalUID, subTopic = false }) => {
  let endpoint = `${backendHost}v1/quizzes/topology/practice_session_seo_topologies/?parent_uid=${goalUID}`;

  if (subTopic) {
    endpoint += '&topic_practice_section=True';
  }

  return fetch(endpoint);
};

export const fetchFreePracticeQuestions = ({ goalUID, topicUID, isGTP }) => {
  const endpoint = isGTP
    ? `${defaultHost}v2/quizzes/question/get_gtp_questions/?uid=${topicUID}&goal_uid=${goalUID}`
    : `${defaultHost}v2/quizzes/question/get_questions/?uid=${topicUID}`;

  return fetch(endpoint);
};

export const fetchPracticesWithFilters = (userName, filters) => {
  const endpoint = `${defaultHost}v1/search_v3/educators/${userName}/dpp_practice/all/?limit=16&filters_applied=${encodeURIComponent(
    JSON.stringify(filters)
  )}`;
  return fetch(endpoint);
};

export const finishPracticeSession = (sessionUid) => {
  return reduxFreeFetcher('v1/quizzes/practice_session/finish/', {
    requestType: 'POST',
    useCamelCase: false,
    body: { uid: sessionUid }
  });
};
